import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { HisSearchResultComponent, HisAuthService, HisConfirmationService, HisUiService, HisNotificationService } from 'hisng';
import { CONFIRMATION_PDIALOG_KEY } from '../../../common/confirmation-dialogs/component/confirmation-dialog.component';
import { INFORMATION_PDIALOG_KEY } from '../../../common/confirmation-dialogs/component/information-dialog.component';
import { BusinesstripApplicationService } from '../service/businesstripapplication.service';

@Component( {
    templateUrl: './businesstripapplication-search-result.component.html'
} )
export class BusinesstripApplicationSearchResultComponent {

    @ViewChild( HisSearchResultComponent, { static: true } ) searchResultComponent!: HisSearchResultComponent;

    readonly SEARCH_CONFIG_PROJECT = 'rm/erp/businesstripapplication/searchBusinesstripApplication.xml';

    constructor( public auth: HisAuthService,
        private confirmationService: HisConfirmationService,
        private notificationService: HisNotificationService,
        private businesstripApplicationService: BusinesstripApplicationService,
        private hisUiService: HisUiService,
        private readonly cd: ChangeDetectorRef ) { }

    public deleteRow( index: number, businesstripApplicationRow: any ) {
        this.businesstripApplicationService.canDeleteBusinesstripApplication( businesstripApplicationRow
            .get( 'BusinesstripApplication.id' ) )
            .subscribe( ( canDelete: string ) => {
                if ( canDelete === '' ) {
                    this.confirm( 'rm.erp.travelmanagement.businesstripapplication.application.delete.confirm'
                        , businesstripApplicationRow, index, canDelete );
                } else {
                    this.confirm( canDelete, businesstripApplicationRow, index, canDelete );
                }
            } );
    }

    private confirm( msg: string, businesstripApplicationRow: any, index: number, canDelete: string ) {
        this.confirmationService.confirm( {
            key: canDelete === '' ? CONFIRMATION_PDIALOG_KEY : INFORMATION_PDIALOG_KEY,
            message: canDelete === '' ? this.hisUiService.translate(
                msg, businesstripApplicationRow.get( 'BusinesstripApplication.id' ) ) : canDelete,
            accept: () => {
                if ( canDelete === '' ) {
                    this.businesstripApplicationService.deleteBusinesstripApplication(
                        businesstripApplicationRow.get( 'BusinesstripApplication.id' ) )
                        .subscribe( ( deleteSuccess: number ) => {
                            if ( deleteSuccess === 1 ) {
                                // Delete Success Message
                                this.notificationService.deleteSuccessI18nRes();
                                // reload page searchResult
                                this.searchResultComponent.reloadPageAfterDelete();
                            }
                        } );
                }
            }
        } );
    }

    page( event: { first: number; rows: number } ) {
        this.searchResultComponent.loadPage( event.first );
        this.searchResultComponent.onPage( event );

        // NG0100: Expression has changed after it was checked fix
        // loadPage und onPage werden aufgerufen, nachdem die Change Detection von HisSearchResultComponent abgeschlossen ist.
        // Daher muss die Change Detection nochmal manuell angestoßen werden
        this.cd.detectChanges();
    }
}
